import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { css, cx } from 'emotion';
import smartypants from 'smartypants';

import InnerWrapper from '../components/inner-wrapper';
import Button from '../components/button';

import gray from '../utils/gray';
import { rte } from '../utils/styles';
import { baselineGrid } from '../utils/presets';
import { toRem, toVW } from '../utils/functions';

const notFound = css`
  max-width: ${toRem(baselineGrid * 100)};
  margin: 8vh auto 16vh;
  text-align: center;
`;

const notFound404 = css`
  display: block;
  margin-bottom: ${toRem(baselineGrid)};
  font-size: 140%;
`;

const notFoundHeading = css`
  font-size: calc(${toRem(baselineGrid * 3)} + ${toVW(baselineGrid * 2)});

  b {
    color: ${gray(64, 'cool')};
  }
`;

const notFoundBtn = css`
  margin: ${toRem(baselineGrid)};
`;

class BackButton extends Component {
  render() {
    return (
      <Button
        className={this.props.className}
        onClick={this.context.router.history.goBack}
        backgroundColor={gray(80, 'cool')}
      >
        {this.props.children}
      </Button>
    );
  }
}

BackButton.contextTypes = {
  router: PropTypes.object.isRequired,
};

BackButton.propTypes = {
  className: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
};

const NotFoundPage = () => (
  <InnerWrapper narrow>
    <div className={cx(rte, notFound)}>
      <h1 className={notFoundHeading}>
        <big className={notFound404}>404</big>
        <span
          dangerouslySetInnerHTML={{
            __html: smartypants("Oh, no! There's <b>nothing</b> here."),
          }}
        />
      </h1>
      <p>
        <BackButton className={notFoundBtn}>{'Go Back'}</BackButton>
        <Button className={notFoundBtn} to="/tumblr-themes/">
          {'Browse Themes'}
        </Button>
      </p>
    </div>
  </InnerWrapper>
);

NotFoundPage.propTypes = {
  history: PropTypes.object,
};

export default NotFoundPage;



// WEBPACK FOOTER //
// ./src/pages/404.js